import { _ctmAxios } from '@/plugins/axios/ctmAxios';

/**
 * @description : 수강신청코드 api 확인
 * @returns : Promise
 */
const checkCtmSugangCode = code => {
  return _ctmAxios.get(`rest/external/codeCheck?code=${code}`);
};

export { checkCtmSugangCode };
